// 打开视频弹窗
function openVideoModal(videoUrl) {
    const modal = document.getElementById('videoModal');
    const container = document.getElementById('modal-player-container');

    // 提取 YouTube Video ID
    let videoId = '';
    if (videoUrl.includes('v=')) {
        videoId = videoUrl.split('v=')[1].split('&')[0];
    } else if (videoUrl.includes('youtu.be/')) {
        videoId = videoUrl.split('youtu.be/')[1].split('?')[0];
    } else if (videoUrl.includes('/embed/')) {
        videoId = videoUrl.split('/embed/')[1].split('?')[0];
    }

    if (!videoId) {
        console.error('Invalid YouTube URL');
        return;
    }

    // 构建 iframe HTML (自动播放 + 静音 + 允许全屏)
    const iframeHtml = `
      <iframe 
        width="100%" 
        height="100%" 
        src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=1&rel=0&modestbranding=1" 
        title="YouTube video player" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen>
      </iframe>
    `;

    container.innerHTML = iframeHtml;
    modal.classList.add('active');
    document.body.style.overflow = 'hidden'; // 禁止背景滚动
}

// 关闭视频弹窗 (点击背景)
function closeVideoModal(event) {
    if (event.target === document.getElementById('videoModal')) {
        closeVideoModalBtn();
    }
}

// 关闭视频弹窗 (点击按钮)
function closeVideoModalBtn() {
    const modal = document.getElementById('videoModal');
    const container = document.getElementById('modal-player-container');

    modal.classList.remove('active');
    container.innerHTML = ''; // 清空 iframe 停止播放
    document.body.style.overflow = 'auto'; // 恢复背景滚动
}

// 监听 ESC 键关闭
document.addEventListener('keydown', function (event) {
    if (event.key === "Escape") {
        closeVideoModalBtn();
    }
});
